<template>
	<v-btn icon @click="cycleTheme" :title="currentLabel">
		<v-icon v-if="currentTheme === 'light'">mdi-white-balance-sunny</v-icon>
		<v-icon v-else-if="currentTheme === 'dark'">mdi-weather-night</v-icon>
		<v-icon v-else>mdi-monitor</v-icon>
	</v-btn>
</template>

<script>
export default {
	name: 'ThemeToggle',
	data() {
		return {
			currentTheme: 'auto', // 'light', 'dark', 'auto'
			systemThemeListener: null
		};
	},
	computed: {
		currentLabel() {
			switch (this.currentTheme) {
				case 'light': return 'Світла тема';
				case 'dark': return 'Темна тема';
				case 'auto': return 'Автоматична (системна)';
				default: return 'Тема';
			}
		}
	},
	mounted() {
		const saved = localStorage.getItem('theme');

		// только определяем режим, без повторного применения темы
		if (saved === 'light' || saved === 'dark') {
			this.currentTheme = saved;
		} else {
			this.currentTheme = 'auto';
		}

		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
		this.systemThemeListener = (e) => {
			if (this.currentTheme === 'auto') {
				this.$vuetify.theme.dark = e.matches;
				// applyThemeClasses + meta сделает main.js через watch
			}
		};

		if (mediaQuery.addEventListener) {
			mediaQuery.addEventListener('change', this.systemThemeListener);
		} else {
			mediaQuery.addListener(this.systemThemeListener);
		}
	},
	beforeDestroy() {
		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
		if (this.systemThemeListener) {
			if (mediaQuery.removeEventListener) {
				mediaQuery.removeEventListener('change', this.systemThemeListener);
			} else {
				mediaQuery.removeListener(this.systemThemeListener);
			}
		}
	},
	methods: {
		cycleTheme() {
			const next = {
				auto: 'light',
				light: 'dark',
				dark: 'auto'
			};

			this.currentTheme = next[this.currentTheme] || 'auto';

			if (this.currentTheme === 'auto') {
				localStorage.removeItem('theme');
			} else {
				localStorage.setItem('theme', this.currentTheme);
			}

			this.applyTheme(this.currentTheme);
		},
		applyTheme(theme) {
			if (theme === 'light') {
				this.$vuetify.theme.dark = false;
			} else if (theme === 'dark') {
				this.$vuetify.theme.dark = true;
			} else {
				const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
				this.$vuetify.theme.dark = prefersDark;
			}

			// для графиков и прочих слушателей
			window.dispatchEvent(new Event('themeChanged'));
		}
	}
};
</script>
